export default __webpack_public_path__ + "static/media/elizabeth-zuniga.0b40ce72.jpeg";